import { render } from "./Procuradores.vue?vue&type=template&id=18f6d4ec&scoped=true"
import script from "./Procuradores.vue?vue&type=script&lang=js"
export * from "./Procuradores.vue?vue&type=script&lang=js"

import "./Procuradores.vue?vue&type=style&index=0&id=18f6d4ec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f6d4ec"]])

export default __exports__